module.exports = __webpack_public_path__ + "img/portraits_24_H.d2c56d7e.webp";